import { render, staticRenderFns } from "./ContainerTabs.vue?vue&type=template&id=d738f5ba&scoped=true&"
import script from "./ContainerTabs.vue?vue&type=script&lang=js&"
export * from "./ContainerTabs.vue?vue&type=script&lang=js&"
import style0 from "./ContainerTabs.vue?vue&type=style&index=0&id=d738f5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d738f5ba",
  null
  
)

export default component.exports